import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "media-layout" }
const _hoisted_2 = { class: "media-nav" }
const _hoisted_3 = { class: "media-tree-header" }
const _hoisted_4 = { class: "media-tree" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tree-folder-label" }
const _hoisted_7 = { class: "tree-folder-count" }
const _hoisted_8 = { class: "tree-children" }
const _hoisted_9 = {
  key: 0,
  class: "tree-empty"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "tree-leaf-text" }
const _hoisted_12 = { class: "tree-leaf-name" }
const _hoisted_13 = { class: "tree-leaf-meta" }
const _hoisted_14 = { class: "media-main" }
const _hoisted_15 = { class: "disk-bar-content" }
const _hoisted_16 = {
  key: 0,
  class: "disk-bar-value"
}
const _hoisted_17 = {
  key: 1,
  class: "disk-bar-value"
}
const _hoisted_18 = { class: "media-tab-wrap" }
const _hoisted_19 = { class: "media-tab-panel" }
const _hoisted_20 = { class: "media-tab-panel" }
const _hoisted_21 = {
  key: 0,
  class: "empty-hint embed-pick-hint"
}
const _hoisted_22 = { class: "drop-zone-title" }
const _hoisted_23 = { class: "drop-zone-hint" }
const _hoisted_24 = {
  key: 0,
  class: "media-file-list"
}
const _hoisted_25 = { class: "media-file-main" }
const _hoisted_26 = { class: "media-file-title" }
const _hoisted_27 = { class: "media-file-meta" }
const _hoisted_28 = {
  class: "media-file-toggle",
  title: "Разрешить скачивание пользователям"
}
const _hoisted_29 = { class: "media-file-actions" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_33 = { class: "section-toggle" }
const _hoisted_34 = { class: "edit-folder-hint" }
const _hoisted_35 = { class: "section-toggle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_AdminVideoUpload = _resolveComponent("AdminVideoUpload")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Загрузка медиатеки",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("aside", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "media-nav-heading" }, "Каталог медиатеки", -1)),
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  size: "small",
                  class: "tree-header-add",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAddSectionModal())),
                  title: "Добавить подраздел"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "icon-only",
                      icon: _ctx.addOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaCategories, (category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category.key,
                    class: "tree-folder"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["tree-folder-row", { 'tree-folder-row--open': _ctx.isCategoryExpanded(category.key), 'tree-folder-row--active': _ctx.selectedMediaCategory === category.key }])
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tree-folder-main",
                        onClick: ($event: any) => (_ctx.toggleCategory(category.key))
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "tree-chevron",
                          icon: _ctx.isCategoryExpanded(category.key) ? _ctx.chevronDownOutline : _ctx.chevronForwardOutline
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_icon, {
                          class: "tree-folder-icon",
                          icon: _ctx.folderOutline
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(category.label), 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.sectionsFor(category.key).length), 1)
                      ], 8, _hoisted_5),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        size: "small",
                        class: "tree-row-action",
                        title: "Добавить подраздел",
                        onClick: _withModifiers(($event: any) => (_ctx.openAddSectionModal(category.key)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.addOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 2),
                    _withDirectives(_createElementVNode("div", _hoisted_8, [
                      (!_ctx.sectionsFor(category.key).length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Нет подразделов"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionsFor(category.key), (s) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: s.id || s.folderKey,
                          class: _normalizeClass(["tree-leaf-row", { 'tree-leaf-row--active': _ctx.selectedSectionKey === s.folderKey && _ctx.selectedMediaCategory === category.key }])
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "tree-leaf-main",
                            onClick: ($event: any) => (_ctx.selectSection(category.key, s.folderKey))
                          }, [
                            _createVNode(_component_ion_icon, {
                              class: "tree-leaf-icon",
                              icon: _ctx.documentOutline
                            }, null, 8, ["icon"]),
                            _createElementVNode("span", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(s.name), 1),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(s.folderKey) + " · " + _toDisplayString(s.availableToAll ? 'всем' : _ctx.roleLabel(s.roleName)), 1)
                            ])
                          ], 8, _hoisted_10),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            size: "small",
                            class: "tree-row-action",
                            title: "Доступы и название",
                            onClick: _withModifiers(($event: any) => (_ctx.openEditSectionModal(s, category.key)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                icon: _ctx.keyOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 2))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.isCategoryExpanded(category.key)]
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass(["disk-bar", _ctx.diskUsageClass])
              }, [
                _createElementVNode("div", {
                  class: "disk-bar-fill",
                  style: _normalizeStyle({ width: _ctx.diskUsagePercent + '%' })
                }, null, 4),
                _createElementVNode("div", _hoisted_15, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "disk-bar-label" }, "Место на сервере", -1)),
                  (_ctx.diskSpace)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Занято " + _toDisplayString(_ctx.diskUsagePercent) + "% · свободно " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.availableBytes)) + " из " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.totalBytes)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, "Загрузка…"))
                ])
              ], 2),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_ion_segment, {
                  value: _ctx.mediaTab,
                  onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMediaTabChange($event))),
                  mode: "ios",
                  class: "liga-glass-segment media-tab-segment"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment_button, {
                      mode: "ios",
                      value: "video"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                            _createTextVNode("Видео", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, {
                      mode: "ios",
                      value: "pdf"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode("PDF", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_19, [
                _createVNode(_component_AdminVideoUpload, {
                  "embed-mode": "",
                  "media-category": _ctx.selectedMediaCategory,
                  "section-folder-key": _ctx.selectedSectionKey
                }, null, 8, ["media-category", "section-folder-key"])
              ], 512), [
                [_vShow, _ctx.mediaTab === 'video']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_20, [
                (!_ctx.selectedSectionKey)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Выберите подраздел выше, чтобы загрузить или просмотреть PDF."))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_ion_card, { class: "admin-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Загрузить PDF в «" + _toDisplayString(_ctx.selectedSectionTitle) + "»", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    label: "Название для пользователей",
                                    "label-placement": "stacked",
                                    modelValue: _ctx.pdfUploadDisplayName,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pdfUploadDisplayName) = $event)),
                                    placeholder: "Отображаемое название материала"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "pdfFileInput",
                                accept: ".pdf,application/pdf",
                                class: "file-input-hidden",
                                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPdfFileSelected && _ctx.onPdfFileSelected(...args)))
                              }, null, 544),
                              _createElementVNode("div", {
                                class: _normalizeClass(["drop-zone", { 'drop-zone--active': _ctx.pdfDragOver, 'drop-zone--has-file': !!_ctx.selectedPdfFile, 'drop-zone--disabled': _ctx.pdfUploadInProgress }]),
                                onDragenter: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPdfDragEnter && _ctx.onPdfDragEnter(...args)), ["prevent"])),
                                onDragover: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPdfDragOver && _ctx.onPdfDragOver(...args)), ["prevent"])),
                                onDragleave: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPdfDragLeave && _ctx.onPdfDragLeave(...args)), ["prevent"])),
                                onDrop: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPdfDrop && _ctx.onPdfDrop(...args)), ["prevent"])),
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pickPdfFile()))
                              }, [
                                _createVNode(_component_ion_icon, {
                                  class: "drop-zone-icon",
                                  icon: _ctx.cloudUploadOutline
                                }, null, 8, ["icon"]),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.selectedPdfFile ? _ctx.selectedPdfFile.name : 'Перетащите PDF сюда'), 1),
                                _createElementVNode("p", _hoisted_23, [
                                  (_ctx.selectedPdfFile)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.formatBytes(_ctx.selectedPdfFile.size)) + " · нажмите, чтобы заменить", 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("или нажмите, чтобы выбрать файл")
                                      ], 64))
                                ])
                              ], 34),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.doPdfUpload())),
                                disabled: !_ctx.canPdfUpload || _ctx.pdfUploadInProgress
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.pdfUploadInProgress ? 'Загрузка…' : 'Загрузить PDF'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, { class: "admin-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("PDF «" + _toDisplayString(_ctx.selectedSectionTitle) + "»", 1)
                                ]),
                                _: 1
                              }),
                              _cache[29] || (_cache[29] = _createElementVNode("p", { class: "admin-card-download-hint" }, "Переключатель «Скачивание» разрешает или запрещает пользователям скачивать файл к себе.", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              (_ctx.pdfs.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pdfs, (p) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: p.id,
                                        class: "media-file-row"
                                      }, [
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("div", _hoisted_26, _toDisplayString(p.displayName), 1),
                                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatBytes(p.fileSizeBytes || 0)), 1)
                                        ]),
                                        _createElementVNode("label", _hoisted_28, [
                                          _createVNode(_component_ion_toggle, {
                                            checked: !!p.allowDownload,
                                            onIonChange: ($event: any) => (_ctx.onPdfAllowDownloadChange(p, $event)),
                                            "aria-label": "Скачивание"
                                          }, null, 8, ["checked", "onIonChange"]),
                                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Скачивание", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "media-icon-btn",
                                            onClick: ($event: any) => (_ctx.renamePdf(p)),
                                            title: "Переименовать"
                                          }, [
                                            _createVNode(_component_ion_icon, { icon: _ctx.pencilOutline }, null, 8, ["icon"])
                                          ], 8, _hoisted_30),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "media-icon-btn media-icon-btn--danger",
                                            onClick: ($event: any) => (_ctx.deletePdf(p)),
                                            title: "Удалить"
                                          }, [
                                            _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                          ], 8, _hoisted_31)
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_32, "Нет PDF материалов в этом подразделе."))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
              ], 512), [
                [_vShow, _ctx.mediaTab === 'pdf']
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.showAddModal,
        onDidDismiss: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeAddSectionModal())),
        class: "admin-releases-modal media-section-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                      _createTextVNode("Новый подраздел", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeAddSectionModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select, {
                    label: "Главный раздел",
                    "label-placement": "stacked",
                    modelValue: _ctx.addForm.mediaCategory,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.addForm.mediaCategory) = $event)),
                    interface: "popover",
                    mode: "ios"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaCategories, (c) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: c.key,
                          value: c.key
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(c.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_input, {
                    label: "Название (для пользователей)",
                    "label-placement": "stacked",
                    modelValue: _ctx.addForm.name,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addForm.name) = $event)),
                    placeholder: "Например: Академия"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_input, {
                    label: "Ключ папки (латиница)",
                    "label-placement": "stacked",
                    modelValue: _ctx.addForm.folderKey,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addForm.folderKey) = $event)),
                    placeholder: "Academia, CoachGP"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("label", _hoisted_33, [
                _cache[32] || (_cache[32] = _createElementVNode("span", null, "Доступно всем", -1)),
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.addForm.availableToAll,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addForm.availableToAll) = $event)),
                  mode: "ios"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_ion_item, {
                class: _normalizeClass({ 'section-role-disabled': _ctx.addForm.availableToAll })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select, {
                    label: "Роль доступа",
                    "label-placement": "stacked",
                    modelValue: _ctx.addForm.roleName,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addForm.roleName) = $event)),
                    interface: "popover",
                    mode: "ios",
                    placeholder: "Выберите роль",
                    disabled: _ctx.addForm.availableToAll
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: a.name,
                          value: a.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_ion_button, {
                expand: "block",
                class: "ion-margin-top",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submitAddSection())),
                disabled: !_ctx.canSubmitAdd || _ctx.addingSection
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.addingSection ? 'Создание…' : 'Добавить подраздел'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.showEditModal,
        onDidDismiss: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeEditSectionModal())),
        class: "admin-releases-modal media-section-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                      _createTextVNode("Доступы раздела", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.closeEditSectionModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.editForm)
            ? (_openBlock(), _createBlock(_component_ion_content, {
                key: 0,
                class: "ion-padding"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_34, "Папка: " + _toDisplayString(_ctx.editForm.folderKey) + " · " + _toDisplayString(_ctx.mediaCategoryLabel(_ctx.editForm.mediaCategory)), 1),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Название (для пользователей)",
                        "label-placement": "stacked",
                        modelValue: _ctx.editForm.name,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editForm.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("label", _hoisted_35, [
                    _cache[34] || (_cache[34] = _createElementVNode("span", null, "Доступно всем", -1)),
                    _createVNode(_component_ion_toggle, {
                      modelValue: _ctx.editForm.availableToAll,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editForm.availableToAll) = $event)),
                      mode: "ios"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_ion_item, {
                    class: _normalizeClass({ 'section-role-disabled': _ctx.editForm.availableToAll })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select, {
                        label: "Роль доступа",
                        "label-placement": "stacked",
                        modelValue: _ctx.editForm.roleName,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editForm.roleName) = $event)),
                        interface: "popover",
                        mode: "ios",
                        placeholder: "Выберите роль",
                        disabled: _ctx.editForm.availableToAll
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: a.name,
                              value: a.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(a.description || a.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    class: "ion-margin-top",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.submitEditSection())),
                    disabled: !_ctx.canSubmitEdit || _ctx.savingSection
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.savingSection ? 'Сохранение…' : 'Сохранить'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    fill: "outline",
                    color: "danger",
                    class: "ion-margin-top",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.confirmDeleteSection())),
                    disabled: _ctx.savingSection || !_ctx.editForm.id
                  }, {
                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                      _createTextVNode(" Удалить подраздел ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-open"])
    ]),
    _: 1
  }))
}